import { render, staticRenderFns } from "./SuccessLottie.vue?vue&type=template&id=1d50e8ec"
import script from "./SuccessLottie.vue?vue&type=script&lang=js"
export * from "./SuccessLottie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports